export const headers = [
  { name: 'Ip', field: 'ip', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
